import FinalizeUser from '@/components/authentication/FinalizeUser';

export const Route = createFileRoute({
	component: FinalizeUser,
	validateSearch: (search) => {
		return {
			token: search.token as string,
			email: search.email as string,
		};
	},
});
